import { Button, HFlow, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Form, SubmitButton, TextField } from 'components/form'
import { FormApi } from 'final-form'
import { useSalvarTipoServicoMutation } from 'graphql/hooks.generated'
import { TipoServicoInput } from 'graphql/types.generated'
import { FormRenderProps } from 'react-final-form'
import { metaPath } from 'util/metaPath'
import { createValidator, maxLength, minLength, required } from 'util/validation'

import { TipoEstabelecimentoField } from './TipoEstabelecimentoField'

export const validate = createValidator<TipoServicoInput>({
  nome: [required, minLength(3), maxLength(30)],
  tiposEstabelecimento: [required],
})

export interface TipoServicoFormProps {
  onCancel(): void
  onSuccess(): void
}

const path = metaPath<TipoServicoInput>()

export function TipoServicoForm(props: Readonly<TipoServicoFormProps>) {
  const { onSuccess, onCancel } = props
  const alert = useAlert()

  const [salvarTipoServico] = useSalvarTipoServicoMutation()

  const handleSubmit = (values: TipoServicoInput, formApi: FormApi) => {
    return salvarTipoServico({ variables: { input: values } }).then(() => {
      const newName: string = values.nome
      alert('success', 'Tipo de serviço ' + newName + ' adicionado com sucesso.')
      onSuccess()
      setTimeout(() => {
        formApi.reset()
        onCancel()
      })
    })
  }

  const handleCancel = (form: FormApi) => {
    onCancel()
    setTimeout(form.reset)
  }

  const renderForm = (formProps: FormRenderProps) => {
    return (
      <VFlow>
        <TextField name={path.nome} label='Nome do tipo de serviço' required />

        <TipoEstabelecimentoField name={path.tiposEstabelecimento} required />

        <HFlow justifyContent='flex-end'>
          <Button size='small' onMouseDown={(e) => e.preventDefault()} onClick={() => handleCancel(formProps.form)}>
            Cancelar
          </Button>
          <SubmitButton size='small' kind='primary' handleSubmit={formProps.handleSubmit}>
            Adicionar
          </SubmitButton>
        </HFlow>
      </VFlow>
    )
  }

  return <Form render={renderForm} onSubmit={handleSubmit} validate={validate} />
}
